import React from 'react';
import {inject, observer} from 'mobx-react'
const PAGE_COUNT = 3;

@inject('purchased')
@observer
export default class Pagination extends React.Component {


  getLeftLinks = () => {
    let res = [];
    for( let i = 1; i <= PAGE_COUNT; i++){
      if((this.props.purchased.currentPage - i) > 0 )
        res.unshift(this.getClickedLink(this.props.purchased.currentPage - i))
    }
    return res;
  };

  getRightLinks = () => {
    let res = [];
    for( let i = 1; i <= PAGE_COUNT; i++){
      if((this.props.purchased.currentPage + i) <= this.props.purchased.totalPages)
        res.push(this.getClickedLink(this.props.purchased.currentPage + i))
    }
    return res;
  };

  getClickedLink = pageNumber => {
    return  (<span onClick={() => this.props.purchased.setPage(pageNumber)}
                   key={pageNumber}>
                  {pageNumber}
                  </span>)
  };


  getActiveLink = () => {
    return <span className='active'>{this.props.purchased.currentPage}</span>
  };

  render(){
    return(
      <div className="workshop-pagination">
        <div className="container">
          <div className="pagination">
            {this.getLeftLinks()}
            {this.getActiveLink()}
            {this.getRightLinks()}
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/purchased/Pagination.jsx